module.exports = __webpack_public_path__ + "img/gzbyjrjd.4585035d.png";